import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IFleetDashboard} from "../../../models/IFleetDashboard";
import {fetchFleetDashboard} from "./actions";

// ── State ───────────────────────────────────────────────────────────────────

interface IFleetDashboardState {
    data: IFleetDashboard | null;
    loading: boolean;
    error: string | null;
    // stale = ждём новых данных после смены периода (затемнение карточек)
    stale: boolean;
}

const initialState: IFleetDashboardState = {
    data: null,
    loading: false,
    error: null,
    stale: false,
};

// ── Slice ───────────────────────────────────────────────────────────────────

export const FleetDashboardSlice = createSlice({
    name: "fleet_dashboard",
    initialState,
    reducers: {
        /** Полный сброс (размонтирование страницы) — данные обнуляются + stale */
        clearFleet: () => ({...initialState, stale: true}),
        /** Пометить данные устаревшими (смена дат) — данные остаются, но затемняются */
        markStale: (state) => {
            state.stale = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFleetDashboard.pending, (state) => {
                state.loading = true;
                state.stale = false;
                state.error = null;
            })
            .addCase(
                fetchFleetDashboard.fulfilled,
                (state, action: PayloadAction<IFleetDashboard>) => {
                    state.data = action.payload;
                    state.loading = false;
                },
            )
            .addCase(fetchFleetDashboard.rejected, (state, action) => {
                state.loading = false;
                if (action.meta.aborted) return;
                if (action.payload === "billing_restricted") return;
                state.error = typeof action.payload === "string"
                    ? action.payload
                    : "Ошибка загрузки сводки по автопарку";
            });
    },
});

export const {clearFleet, markStale} = FleetDashboardSlice.actions;
export default FleetDashboardSlice.reducer;
